import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-bank-details-content',
  templateUrl: './bank-details-content.component.html',
  styleUrls: ['./bank-details-content.component.scss'],
})
export class BankDetailsContentComponent implements OnInit {

  @Input() key: string;
  @Input() data: any;
  @Input() showTitle: boolean;
  @Input() buttons: ('back' | 'continue')[] = ['back', 'continue'];
  @Output() back = new EventEmitter();
  @Output() continue = new EventEmitter();

  constructor() { }

  async ngOnInit() {

  }


}
